import React from 'react'



class Precio extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      precioFinal: {},
      tamano: "grande"
     };

  }

componentDidUpdate(prevProps){
  if (this.props.producto1 !== prevProps.producto1 || this.props.producto2 !== prevProps.producto2) {
    let x;
    var precioFinal = {};

    for(x in this.props.producto1){
      precioFinal[x] = (this.props.producto1[x] + (this.props.producto2 !== undefined ? this.props.producto2[x] : 0)) / (this.props.producto2 !== undefined ? 2 : 1);
    }

    //console.log("precioFinal", precioFinal)

    this.setState({precioFinal: precioFinal})

    this.props.precioSeleccionado(precioFinal, this.state.tamano);

    //console.log("en precio didupdate")
  }


  //console.log("prop en preciofinal", precioFinal)

}

onChange(event) {
  //console.log("checkbox tocado", event.target.name, event.target.id)

  this.setState({tamano: event.target.id});

  this.props.precioSeleccionado(this.state.precioFinal, event.target.id);


}

  render() {

    var tamanos = Object.keys(this.state.precioFinal)

    let precioFinal = Object.values(this.state.precioFinal);
    var preciosOrdenados = []

    precioFinal.map(ordenaPrecios);

    function ordenaPrecios(item, index){
      //console.log("ordenaPrecios", item, index)

      if(item > 0) {
        preciosOrdenados[item.toFixed()] = { "tamano": tamanos[index], "precio": item }
      }
    }

    const classOpcionSeleccionada = "col custom-control custom-radio custom-control-inline badge badge-pill btn btn-success pl-3";
    const classOpcionNoSeleccionada = "col custom-control custom-radio custom-control-inline badge badge-pill btn btn-outline-success pl-3";

    const Items = preciosOrdenados.map((todo, i) =>
    <div key={todo.tamano} className={todo.tamano===this.state.tamano ? classOpcionSeleccionada : classOpcionNoSeleccionada}>
      <input type="radio" id={todo.tamano} onChange={event => this.onChange(event)} name="customRadioInline1" className="custom-control-input" checked={todo.tamano===this.state.tamano ? true : false}/>
      <label className="custom-control-label" htmlFor={todo.tamano}><span className="badge badge-pill badge-warning">{todo.tamano.toUpperCase()}</span><br /><span className="precio">$ {todo.precio}</span></label>
    </div>
    );


    return (
      <div>
        <div className="Precio container mt-2">
          <div className="row mx-auto">
            {Items}
          </div>
        </div>

      </div>
    )
  }
}

export default Precio
